import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserManagerService {
  public userInfo$: BehaviorSubject<any | null> = new BehaviorSubject<any | null>(null);

  public USER_INFO = 'userInfo';
  public USER_ID = 'user_id';

  // TODO recuperare l'id dal token dopo l'autenticazione
  private _userId; // = "100ddfa1-47ea-4c78-90c0-bb3e15040261";

  constructor() {}

  /**
   * Returns the user info: credentials, properties and groups
   */
  get userInfo() {
    return this.userInfo$.value;
  }

  /**
   * Returns the User ID
   */
  get userId() {
    return this._userId;
  }

  /**
   * Sets User ID
   */
  set userId(id) {
    sessionStorage.setItem(this.USER_ID, id);
    this._userId = id;
  }

  /**
   * To load user Info
   * @param userInfo
   * @example {
   *    properties: {},
   *    credentials: {},
   *    groups: []
   * }
   */
  setUserInfo(userInfo) {
    this.userInfo$.next(userInfo);
  }
}
